import { render, staticRenderFns } from "./navCom.vue?vue&type=template&id=96579446&scoped=true"
import script from "./navCom.vue?vue&type=script&lang=js"
export * from "./navCom.vue?vue&type=script&lang=js"
import style0 from "./navCom.vue?vue&type=style&index=0&id=96579446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96579446",
  null
  
)

export default component.exports